import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';
import actions from '../constants';
import selectOrganization from '../../organizations/actions/selectOrganization';

export default user => async (dispatch, getState) => {
  await dispatch({
    type: actions.LOGON_FINISH,
    payload: {
      id: user.uid,
      name: user.displayName,
      email: user.email,
    },
  });

  const currentLocation = browserHistory.getCurrentLocation();

  await dispatch(selectOrganization(getState().getIn(['organization', 'id'], user.uid)));
  await dispatch(push(currentLocation));
};



// WEBPACK FOOTER //
// ./src/modules/auth/actions/logon.js